import React, { useEffect, useState, useContext } from 'react'
import EquipmentService from '../../../../../../services/api/equipment.service'
import AddEquipment from '../../../equipment/add-equipment/AddEquipment'
import EditEquipment from '../../../equipment/edit-equipment/EditEquipment'
import ModalBox from '../../../../../templates/components/ModalBox'
import Table2 from '../../../../../templates/components/Table2'
import { store } from '../../../../../../context/StateProvider'
import PracticeLocationSelector from '../../../../../templates/components/PracticeLocationSelector'
import APIResponse from '../../../../../templates/components/APIResponse'
import DimLoader from '../../../../../templates/components/DimLoader'
const EquipmentSettings = (props) => {
    const globalStateAndDispatch = useContext(store)
    const contextState = globalStateAndDispatch.state
    const dispatch = globalStateAndDispatch.dispatch
    const [isLoader_Equipment, setIsLoader_Equipment] = useState(false)
    const [isLoader, setIsLoader] = useState(false)
    const [isLoader_EquipmentType, setIsLoader_EquipmentType] = useState(false)
    const [equipmentList, setEquipmentList] = useState()
    const [equipmentTypeList, setEquipmentTypeList] = useState()
    const [selectEquipment, setSelectedEquipment] = useState()
    const [deleteModal, setDeleteModal] = useState(false)
    // For forms 
    const [showEquipmentAdd, setShowEquipmentAdd] = useState(false)

    const [showEquipmentEdit, setShowEquipmentEdit] = useState(false)
    const [equipmentId, setEquipmentId] = useState()
    const [statusModal, setStatusModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [override, setOverride] = useState(false);
    const [apiResponse, setApiResponse] = useState()
    const [locationId, setLocationId] = useState(contextState.practiceLocationId || null);
    const hiddenColumns = ["isActive", "actionEquipment"]
    const onSuccess = (message) => {
        setEquipmentList()
        equipmentLookup();
        dispatch({
            type: "setLocationEquipment",
            payload: null
        });
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    const onError = (message) => {
        if (selectEquipment.isActive == 1) {
            if (apiResponse.response?.data?.message === "Key_EquipmentInUseInAppointments") {
                setConfirmModal(true)
            }
        }
    }

    const onLocationChanged = (newLocationId) => {
        setLocationId(newLocationId)
    }

    const statusHandler = () => {
        setConfirmModal(false);
        setStatusModal(false);
        setIsLoader(true)
        if (selectEquipment.isActive == 1) {
            let reqObj = {}
            if (override) {
                reqObj.override = override
            }
            EquipmentService.deactivateEquipment(selectEquipment.equipmentId, reqObj).then(response => {
                setApiResponse(response)
            })
                .catch(error => {
                    setApiResponse(error)
                })
                .finally(() => {
                    setOverride(false)
                    setIsLoader(false)
                });

        } else {
            EquipmentService.activateEquipment(selectEquipment.equipmentId).then(response => {
                setApiResponse(response)
            })
                .catch(error => {
                    setApiResponse(error)
                })
                .finally(() => {
                    setIsLoader(false)
                });
        }
    };
    const equipmentLookup = () => {
        setIsLoader_Equipment(true);
        EquipmentService.equipmentLookup(locationId)
            .then((response) => {
                setEquipmentList(response);
            })
            .catch(error => {})
            .finally(() => {
                setIsLoader_Equipment(false)
            });
    }

    const equipmentTypeLookup = () => {
        setIsLoader_EquipmentType(true);
        EquipmentService.equipmentTypeLookup()
            .then((response) => {
                setEquipmentTypeList(response);
                setIsLoader_EquipmentType(false);
            })
            .catch(error => {
                setIsLoader_EquipmentType(false);
            })

    }

    const deleteEquipment = (id) => {
        setDeleteModal(false)
        setIsLoader(true)
        EquipmentService.deleteEquipment(id)
            .then(response => {
                setApiResponse(response)
            })
            .catch(error => {
                setApiResponse(error)
            })
            .finally(() => {
                setIsLoader(false)
            });
    }

    useEffect(() => {
        if (override) {
            statusHandler();
        }
    }, [override])
    useEffect(() => {
        if (locationId) {
            setEquipmentList()
            equipmentLookup()
        }
    }, [locationId])
    useEffect(() => {
        equipmentTypeLookup()
    }, [])

    const equipmentColumns = [
        {
            id: "description",
            Header: "Name",
            accessor: equipment => equipment.description
        },
        {
            id: "equipmentTypeId",
            Header: "Equipment Type",
            accessor: (equipment) => { if (equipmentTypeList) { return equipmentTypeList.find(obj => obj.equipmentTypeId === equipment.equipmentTypeId)?.equipmentType } }
        }, {
            id: "isActive",
            Header: "Active",
            align: "center",
            sortable: true,
            accessor: (equipment, i) =>
                equipment.isActive === 1 ? (
                    <span className="btn btn-success text-white">Active</span>
                ) : (
                    <span className="btn btn-danger text-white">Inactive</span>
                ),
        },
        {
            id: "actionEquipment",
            Header: "Action",
            textAlign: 'center',
            disableSortBy: true,
            accessor: (equipment, i) => {
                return (
                    <div className='d-flex justify-content-center'>
                        <button className="p-0 ps-1 btn btn-primary" title="edit" onClick={e => { e.preventDefault(); setEquipmentId(equipment.equipmentId); return setShowEquipmentEdit(true) }}><i className="icon pencil" /></button>
                        <button className="p-0 ps-1 btn btn-primary ms-1" title="delete" onClick={e => { e.preventDefault(); setSelectedEquipment(equipment); return setDeleteModal(true) }}><i className="icon trash" /></button>
                        <button
                            className="p-0 ps-1 btn btn-primary ms-1"
                            title={
                                equipment.isActive === 1 ? "Deactivate Equipment" : "Activate Equipment"
                            }
                            onClick={(e) => {
                                e.preventDefault();
                                setSelectedEquipment(equipment);
                                return setStatusModal(true);
                            }}
                        >
                            {equipment.isActive === 1 ? <i className="icon dont" /> : <i className="icon check" />}
                        </button>
                    </div>
                )
            }
        }
    ]

    return (
        <> {isLoader && <DimLoader/>}
            <div title="Equipment" className='py-3'>
                <Table2
                    hiddenColumns={hiddenColumns}
                    export searchable
                    data={equipmentList}
                    columns={equipmentColumns}
                    loading={isLoader_Equipment}
                    extraButtons={[
                        {
                            className: 'btn btn-primary',
                            title: "Add Equipment",
                            children:
                                <span><i className='icon plus' /></span>
                            ,
                            onClick: () => {
                                setShowEquipmentAdd(true)
                            }
                        }

                    ]}
                    extraElements={[
                        { children: <div style={{ width: '250px' }}> <PracticeLocationSelector dontResetState={true} onSelected={onLocationChanged} /> </div> },
                    ]} />
            </div>
            <ModalBox open={showEquipmentAdd} onClose={() => { setShowEquipmentAdd(false) }} title="Add Equipment">
                <AddEquipment initialData={{ practiceLocationId: locationId }} onClose={() => { setShowEquipmentAdd(false) }}
                    refresh={() => {
                        equipmentLookup();
                    }} />
            </ModalBox>
            <ModalBox open={showEquipmentEdit} onClose={() => { setShowEquipmentEdit(false) }} title="Edit Equipment">
                <EditEquipment id={equipmentId} onClose={() => { setShowEquipmentEdit(false) }}
                    refresh={() => {
                        equipmentLookup();
                    }} />
            </ModalBox>
            <ModalBox open={deleteModal} onClose={() => { setDeleteModal(false) }} title="Delete Equipment">
                {selectEquipment?.equipmentId && <div className='row d-flex align-items-center justify-content-between'>
                    <div className='col'>
                        Are you sure you want to delete {selectEquipment.description} ?
                    </div>
                    <div className='col-auto'>
                        <button className='btn btn-secondary' onClick={e => { e.preventDefault(); return setDeleteModal(false) }}>No</button>
                        <button className='btn btn-primary ms-3' onClick={e => { e.preventDefault(); deleteEquipment(selectEquipment.equipmentId);  }}>Yes</button>
                    </div>
                </div>}
            </ModalBox>
            <ModalBox open={statusModal} onClose={() => setStatusModal(false)} title={selectEquipment?.isActive === 1 ? "Deactivate Equipment" : "Activate Equipment"}>
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        {selectEquipment?.isActive === 1 ? (
                            <p>Would you like to deactivate {selectEquipment?.description}</p>
                        ) : (
                            <p>Would you like to activate {selectEquipment?.description} </p>
                        )}
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                statusHandler();
                            }}
                        >
                            OK
                        </button>
                        <button
                            className="btn btn-secondary ms-3"
                            onClick={(e) => {
                                e.preventDefault();
                                setStatusModal(false);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>
            <ModalBox open={confirmModal} onClose={() => setConfirmModal(false)} title="Confirm">
                <div className="row d-flex justify-content-between align-items-center">
                    <div className="col">
                        <p>Do you want to deactivate {selectEquipment?.description} while it's in use?</p>
                    </div>
                    <div className="col-auto">
                        <button
                            className="btn btn-primary"
                            onClick={(e) => {
                                e.preventDefault();
                                setOverride(true);
                            }}
                        >
                            OK
                        </button>
                        <button
                            className="btn btn-secondary ms-3"
                            onClick={(e) => {
                                e.preventDefault();
                                setConfirmModal(false);
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </ModalBox>
            <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} toastOnFailure={true} onError={onError} />
        </>
    )
}

export default EquipmentSettings